<script>
  export let title;
  export let onClose;
</script>

<div class="dashboardWidgetTitleContainer">
  <span>{title}</span>
  <img class="closeIcon" src="images/x.svg" alt="Close" on:click={onClose} />
</div>

<style>
  div.dashboardWidgetTitleContainer {
    height: 45px;
    width: 100%;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
    border-bottom-style: solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    padding-left: 10px;
    padding-right: 10px;
    color: var(--labit-card-gray);
  }

  img.closeIcon {
    width: 15px;
    cursor: pointer;
  }
</style>
